import { createSlice, nanoid } from "@reduxjs/toolkit";
const TempModalBody = () => {
  return (
    <div>
      <h1>Modal Body not provided</h1>
    </div>
  );
};
const initialState = {
  isOpen: false,
  isEditing: false,
  data: null,
  title: "",
  isHeader: true,
  body: <TempModalBody />,
  ids: {},
};

export const modal = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isHeader =
        action.payload.isHeader === undefined ? true : action.payload.isHeader;
      Object.keys(action.payload).forEach((key) => {

        console.log("modalState openModal action.payload", action.payload+" key: ", key);
        
        if (
          key in state &&
          action.payload[key] !== undefined &&
          action.payload[key] !== null
        ) {
          state[key] = action.payload[key];
        }
      });

      if (action.payload.body === null && state.body === "") {
        state.body = <TempModalBody />;
      }
    },
    updateIds: (state, action) => {
      state.ids = { ...state.ids, ...action.payload };
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.isEditing = false;
    },
  },
});

export const { openModal, closeModal, updateIds } = modal.actions;
export default modal.reducer;
